// components/Gallery.js
import React, { useState, useEffect } from 'react';
import './Gallery.css';
import GalleryModal from './GalleryModal'; // Import the new modal component

// Import all images. For those moved to public, their imports will still resolve
// to the correct public URL if the bundler is configured to do so.
// However, to be explicit and avoid potential issues, we will use direct paths
// for the images moved to public/img.

import imgAdditional1 from '../img/Additional (1).png';
import imgAdditional2 from '../img/Additional (2).png';
import imgAdditional3 from '../img/Additional (3).png';
import imgAdditional4 from '../img/Additional (4).png';
import imgAdditional5 from '../img/Additional (5).png';
import imgAdditional6 from '../img/Additional (6).png';
import imgAdditional7 from '../img/Additional (7).png';
import imgAdditional8 from '../img/Additional (8).png';
import imgBedroom1_1 from '../img/Bedroom 1 (1).png';
import imgBedroom1_2 from '../img/Bedroom 1 (2).png';
import imgBedroom1_3 from '../img/Bedroom 1 (3).png';
import imgBedroom2_1 from '../img/Bedroom 2 (1).png';
import imgBedroom2_2 from '../img/Bedroom 2 (2).png';
import imgBedroom2_3 from '../img/Bedroom 2 (3).png';
import imgBedroom3 from '../img/Bedroom 3.png';
import imgExterior from '../img/Exterior.png';
import imgFullBathroom from '../img/Full Bathroom.png';
import imgKitchenette1 from '../img/Kitchenette (1).png';
import imgKitchenette10 from '../img/Kitchenette (10).png';
import imgKitchenette2 from '../img/Kitchenette (2).png';
import imgKitchenette3 from '../img/Kitchenette (3).png';
import imgKitchenette4 from '../img/Kitchenette (4).png';
import imgKitchenette5 from '../img/Kitchenette (5).png';
import imgKitchenette6 from '../img/Kitchenette (6).png';
import imgKitchenette7 from '../img/Kitchenette (7).png';
import imgKitchenette8 from '../img/Kitchenette (8).png';
import imgKitchenette9 from '../img/Kitchenette (9).png';
import imgLivingRoom1 from '../img/Living room (1).png';
import imgLivingRoom10 from '../img/Living room (10).png';
import imgLivingRoom11 from '../img/Living room (11).png';
import imgLivingRoom12 from '../img/Living room (12).png';
import imgLivingRoom13 from '../img/Living room (13).png';
import imgLivingRoom14 from '../img/Living room (14).png';
import imgLivingRoom15 from '../img/Living room (15).png';
import imgLivingRoom16 from '../img/Living room (16).png';
import imgLivingRoom2 from '../img/Living room (2).png';
import imgLivingRoom3 from '../img/Living room (3).png';
import imgLivingRoom4 from '../img/Living room (4).png';
import imgLivingRoom5 from '../img/Living room (5).png';
import imgLivingRoom6 from '../img/Living room (6).png';
import imgLivingRoom7 from '../img/Living room (7).png';
import imgLivingRoom8 from '../img/Living room (8).png';
import imgLivingRoom9 from '../img/Living room (9).png';



const allImages = [
  { id: 1, src: imgLivingRoom1, category: 'Living Area', title: 'Living room (1)' },
  { id: 2, src: imgLivingRoom2, category: 'Living Area', title: 'Living room (2)' },
  { id: 3, src: imgLivingRoom3, category: 'Living Area', title: 'Living room (3)' },
  { id: 4, src: imgLivingRoom4, category: 'Living Area', title: 'Living room (4)' },
  { id: 5, src: imgLivingRoom5, category: 'Living Area', title: 'Living room (5)' },
  { id: 6, src: imgLivingRoom6, category: 'Living Area', title: 'Living room (6)' },
  { id: 7, src: imgLivingRoom7, category: 'Living Area', title: 'Living room (7)' },
  { id: 8, src: imgLivingRoom8, category: 'Living Area', title: 'Living room (8)' },
  { id: 9, src: imgLivingRoom9, category: 'Living Area', title: 'Living room (9)' },
  { id: 10, src: imgLivingRoom10, category: 'Living Area', title: 'Living room (10)' },
  { id: 11, src: imgLivingRoom11, category: 'Living Area', title: 'Living room (11)' },
  { id: 12, src: imgLivingRoom12, category: 'Living Area', title: 'Living room (12)' },
  { id: 13, src: imgLivingRoom13, category: 'Living Area', title: 'Living room (13)' },
  { id: 14, src: imgLivingRoom14, category: 'Living Area', title: 'Living room (14)' },
  { id: 15, src: imgLivingRoom15, category: 'Living Area', title: 'Living room (15)' },
  { id: 16, src: imgLivingRoom16, category: 'Living Area', title: 'Living room (16)' },
  { id: 17, src: imgKitchenette1, category: 'Kitchen', title: 'Kitchenette (1)' },
  { id: 18, src: imgKitchenette2, category: 'Kitchen', title: 'Kitchenette (2)' },
  { id: 19, src: imgKitchenette3, category: 'Kitchen', title: 'Kitchenette (3)' },
  { id: 20, src: imgKitchenette4, category: 'Kitchen', title: 'Kitchenette (4)' },
  { id: 21, src: imgKitchenette5, category: 'Kitchen', title: 'Kitchenette (5)' },
  { id: 22, src: imgKitchenette6, category: 'Kitchen', title: 'Kitchenette (6)' },
  { id: 23, src: imgKitchenette7, category: 'Kitchen', title: 'Kitchenette (7)' },
  { id: 24, src: imgKitchenette8, category: 'Kitchen', title: 'Kitchenette (8)' },
  { id: 25, src: imgKitchenette9, category: 'Kitchen', title: 'Kitchenette (9)' },
  { id: 26, src: imgKitchenette10, category: 'Kitchen', title: 'Kitchenette (10)' },
  { id: 27, src: imgBedroom1_1, category: 'Bedroom 1', title: 'Bedroom 1 (1)' },
  { id: 28, src: imgBedroom1_2, category: 'Bedroom 1', title: 'Bedroom 1 (2)' },
  { id: 29, src: imgBedroom1_3, category: 'Bedroom 1', title: 'Bedroom 1 (3)' },
  { id: 30, src: imgBedroom2_1, category: 'Bedroom 2', title: 'Bedroom 2 (1)' },
  { id: 31, src: imgBedroom2_2, category: 'Bedroom 2', title: 'Bedroom 2 (2)' },
  { id: 32, src: imgBedroom2_3, category: 'Bedroom 2', title: 'Bedroom 2 (3)' },
  { id: 33, src: imgBedroom3, category: 'Bedroom 3', title: 'Bedroom 3' },
  { id: 34, src: imgFullBathroom, category: 'Bathroom', title: 'Full Bathroom' },
  { id: 35, src: imgExterior, category: 'Exterior', title: 'Exterior' },
  { id: 36, src: imgAdditional1, category: 'Additional', title: 'Additional (1)' },
  { id: 37, src: imgAdditional2, category: 'Additional', title: 'Additional (2)' },
  { id: 38, src: imgAdditional3, category: 'Additional', title: 'Additional (3)' },
  { id: 39, src: imgAdditional4, category: 'Additional', title: 'Additional (4)' },
  { id: 40, src: imgAdditional5, category: 'Additional', title: 'Additional (5)' },
  { id: 41, src: imgAdditional6, category: 'Additional', title: 'Additional (6)' },
  { id: 42, src: imgAdditional7, category: 'Additional', title: 'Additional (7)' },
  { id: 43, src: imgAdditional8, category: 'Additional', title: 'Additional (8)' },
];


const categories = ['All', ...new Set(allImages.map(image => image.category))];

function Gallery() {
  const [filter, setFilter] = useState('All');
  const [filteredImages, setFilteredImages] = useState(allImages);
  const [showModal, setShowModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  useEffect(() => {
    if (filter === 'All') {
      setFilteredImages(allImages);
    } else {
      setFilteredImages(allImages.filter(image => image.category === filter));
    }
  }, [filter]);

  const openModal = (index) => {
    setSelectedImageIndex(index);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <section id="gallery" className="gallery-section">
      <h2 className="reveal">Our Photo Gallery</h2>
      <div className="filter-buttons reveal">
        {categories.map(category => (
          <button
            key={category}
            className={filter === category ? 'active' : ''}
            onClick={() => setFilter(category)}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="image-grid reveal">
        {filteredImages.map((image, index) => (
          <div key={image.id} className="gallery-item" onClick={() => openModal(index)}> {/* Add onClick */}
            <img src={image.src} alt={image.title} />
            <div className="image-title">{image.title}</div>
          </div>
        ))}
      </div>

      {showModal && (
        <GalleryModal
          images={filteredImages} // Pass filtered images to modal
          initialIndex={selectedImageIndex}
          onClose={closeModal}
        />
      )}
    </section>
  );
}

export default Gallery;